export const locationCatalog = [
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de M\u00e9xico",
  "CDMX",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de M\u00e9xico",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoac\u00e1n",
  "Morelos",
  "Nayarit",
  "Nuevo Le\u00f3n",
  "Oaxaca",
  "Puebla",
  "Quer\u00e9taro",
  "Quintana Roo",
  "San Luis Potos\u00ed",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucat\u00e1n",
  "Zacatecas",
  "Culiac\u00e1n",
  "Culiac\u00e1n, Sinaloa",
  "Las Quintas",
  "Valle Alto",
  "Bachigualato",
  "Bacurim\u00ed",
  "Chapultepec",
  "Portalegre",
  "Los Pinos",
  "L\u00e1zaro C\u00e1rdenas",
  "Barrancos",
  "Stanza Cantabria",
  "Tijuana",
  "Tijuana, Baja California",
  "Otay",
  "Mesa de Otay",
  "Otay Universidad",
  "Coyoac\u00e1n, Ciudad de M\u00e9xico",
  "Del Valle, Ciudad de M\u00e9xico",
  "Roma Norte, Ciudad de M\u00e9xico",
  "Roma Sur, Ciudad de M\u00e9xico",
  "Condesa, Ciudad de M\u00e9xico",
  "Polanco, Ciudad de M\u00e9xico",
  "Narvarte, Ciudad de M\u00e9xico",
  "N\u00e1poles, Ciudad de M\u00e9xico",
  "Santa Fe, Ciudad de M\u00e9xico",
  "San \u00c1ngel, Ciudad de M\u00e9xico",
  "Doctores, Ciudad de M\u00e9xico",
  "Centro, Ciudad de M\u00e9xico",
  "Cuauht\u00e9moc, Ciudad de M\u00e9xico",
  "Benito Ju\u00e1rez, Ciudad de M\u00e9xico",
  "Miguel Hidalgo, Ciudad de M\u00e9xico",
  "\u00c1lvaro Obreg\u00f3n, Ciudad de M\u00e9xico",
  "Tlalpan, Ciudad de M\u00e9xico",
  "Iztapalapa, Ciudad de M\u00e9xico",
  "Azcapotzalco, Ciudad de M\u00e9xico",
  "Venustiano Carranza, Ciudad de M\u00e9xico",
];